export const QUICK_START_ITEMS = [
  { key: 'kagemane', icon: 'kagemane', templateId: null },
  { key: 'outfitExtension', icon: 'outfit-extension', templateId: '1d3c0538-49cb-4c4d-a0f6-6d2b1f7b82e5' },
  { key: 'silhouetteExtension', icon: 'silhouette-extension', templateId: '8f5ddf57-29d6-47df-9a91-bf7cbf1c8d41' },
  { key: 'whiteBackground', icon: 'white-background', templateId: '85a30854-0450-4555-a888-53c7184a24a3' },
  { key: 'lookbook', icon: 'lookbook', templateId: 'fc9418f7-08f6-4d5c-97db-253d17212000' },
  { key: 'virtualTryOn', icon: 'virtual-try-on', templateId: '5664690f-5bfd-4350-b361-f018fd376c4f' },
] as const;

export type QuickStartKey = typeof QUICK_START_ITEMS[number]['key'];
export interface QuickStartMedia {
  media_type: 'image' | 'video';
  media_url: string;
  poster_url: string;
}
export type QuickStartMediaSettings = Record<QuickStartKey, QuickStartMedia>;
